import EditTypePageComponent from "./components/EditTypePageComponent";

import axios from "axios";

const fetchType = async (typeId) => {
    const { data } = await axios.get(`/api/types/${typeId}`);
    return data;
}

const updateTypeApiRequest = async (typeId, formInputs) => {
    const { data } = await axios.put(`/api/types/${typeId}`, { ...formInputs });
    return data;
}

const AdminEditTypePage = () => {
  
  return <EditTypePageComponent updateTypeApiRequest={updateTypeApiRequest} fetchType={fetchType} />;
};


export default AdminEditTypePage;
